import { createAction, props } from '@ngrx/store';
import { Profile } from './authentication.state';

export const init = createAction('[authentication] init')

export const signIn = createAction('[authentication] sign-in', props<{ landingUrl: string }>())

export const signedIn = createAction('[authentication] signed in', props<{ user: Profile, redirectToUrl: string | undefined }>())

export const signInFailed = createAction('[authentication] sign in failed', props<{ error: Error }>())

export const signOut = createAction('[authentication] sign out')

export const signedOut = createAction('[authentication] signed out')
